import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import gql from "graphql-tag";

const ReferralCodePropertiesPanel = (props) => {

  let elements = null;
  if (!props.code) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "code", label: "Id", type: "string"},
      {prop: "description", label: "description", type: "text"},
      {prop: "active", label: "Active", type: "boolean"},
      {prop: "createdAt", label: "Created", type: "date"},
    ])
    let variables = {code: props.code}
    elements = (
      <Query query={GET_REFERRAL_CODE} variables={variables} skip={!props.code} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.referralCode)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Referral Code" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

const GET_REFERRAL_CODE = gql`
  query referralCode($code: ID!) {
    referralCode(code: $code) {
      code
      description
      active
      createdAt
    }
  }
`;

export default ReferralCodePropertiesPanel;